import React from 'react';
import { Box } from '@mui/material';


export default function ImagePreview({ url, faded = false, width = 140, height = 90 }) {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => { setFailed(false); }, [url]);
  if (!url || failed) return null;
  return (
    <Box
      component="img"
      src={url}
      alt=""
      onError={() => setFailed(true)}
      sx={{
        display: 'block',
        mt: 0.75,
        width,
        maxWidth: '100%',
        height,
        objectFit: 'cover',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        opacity: faded ? 0.6 : 1,
      }}
    />
  );
}
